"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }



var _smsDelivery = require('shared/services/smsDelivery');


var _timeZones = require('shared/services/timeZones');

// chat_archived is on older rows only (archiving no longer stops a send);
// they read just "Not sent".
// The undeliverable-list reasons' text lives with the rest of that copy.
const FAILURE_TEXT = {
  ..._smsDelivery.SMS_UNDELIVERABLE_SCHEDULED_FAILURE_TEXT,
  patient_removed: 'Not sent: patient left the chat',
  send_error: "Not sent: couldn't send",
  interrupted: 'Not sent: interrupted',
}

 const failureReasonText = (reason) =>
  (reason && FAILURE_TEXT[reason]) || 'Not sent'; exports.failureReasonText = failureReasonText

const withYear = (sendAt, now, timeZone) =>
  _timeZones.wallClock.call(void 0, sendAt, timeZone).year !== _timeZones.wallClock.call(void 0, now, timeZone).year

/* "Thu, Oct 9, 8:00 AM", in the zone the user schedules in. Another zone
 * than the device's says which: "Thu, Oct 9, 8:00 AM EDT". */
 const formatScheduledTime = (
  sendAt, now = new Date(), timeZone = _timeZones.deviceTimeZone.call(void 0, ),
) => {
  const date = new Date(sendAt)
  const time = _timeZones.formatInZone.call(void 0, date, timeZone, withYear(date, now, timeZone) ? 'ddd, MMM D, YYYY, h:mm A' : 'ddd, MMM D, h:mm A')
  return timeZone === _timeZones.deviceTimeZone.call(void 0, ) ? time : `${time} ${_timeZones.zoneAbbreviation.call(void 0, date, timeZone)}`.trim()
}; exports.formatScheduledTime = formatScheduledTime

// "Thursday, October 9 at 8:00 AM", for screen readers, with the zone's name
// when it isn't the device's.
 const spokenScheduledTime = (
  sendAt, now = new Date(), timeZone = _timeZones.deviceTimeZone.call(void 0, ),
) => {
  const date = new Date(sendAt)
  const time = _timeZones.formatInZone.call(void 0, 
    date, timeZone, withYear(date, now, timeZone) ? 'dddd, MMMM D, YYYY [at] h:mm A' : 'dddd, MMMM D [at] h:mm A')
  return timeZone === _timeZones.deviceTimeZone.call(void 0, ) ? time : `${time}, ${_timeZones.timeZoneName.call(void 0, timeZone, date)}`
}; exports.spokenScheduledTime = spokenScheduledTime

// The line under the time pickers: the zone their times are in, shown as
// already chosen ("Time zone: Pacific Time (PT)"), the device's unless the
// user changed it. Change is only for when it's wrong.
 const scheduleZoneLine = (timeZone, at = new Date()) =>
  ({ label: 'Time zone:', value: _timeZones.timeZoneName.call(void 0, timeZone, at) }); exports.scheduleZoneLine = scheduleZoneLine









// Reads a refused scheduled-message command: wsCommand rethrows a client error
// as a CommandError whose `extra` is the response; a FAILURE action carries
// the response itself.
 const scheduledMessageErrorFrom = (error) => {
  if (!error || typeof error !== 'object') return { code: null, current: null, message: undefined }
  const e = error 
  const data = (e.extra && typeof e.extra === 'object' ? e.extra : e) 
  const code = data.ErrorCode === 'scheduled_message_changed' || data.ErrorCode === 'scheduled_message_not_scheduled' ||
    data.ErrorCode === 'scheduled_message_retry_refused'
    ? data.ErrorCode
    : null
  const current = code && data.Current && typeof data.Current === 'object'
    ? data.Current 
    : null
  return { code, current, message: typeof data.Error === 'string' ? data.Error : undefined }
}; exports.scheduledMessageErrorFrom = scheduledMessageErrorFrom

// Only its author can change a scheduled message, so a newer version came
// from their own other device.
 const STALE_MESSAGE_TEXT = 'You changed this message on another device. Reload.'; exports.STALE_MESSAGE_TEXT = STALE_MESSAGE_TEXT

const MOVED_ON_TEXT = {
  sending: 'This message is already sending.',
  sent: 'This message has already been sent.',
  failed: "This message wasn't sent.",
}

// The Cancel dialog's body: who the message won't go to, by name.
 const cancelScheduledBody = (recipientName) =>
  recipientName.trim() ? `It won't be sent to ${recipientName.trim()}.` : "It won't be sent."; exports.cancelScheduledBody = cancelScheduledBody

const SEND_LATER_TEXT = {
  'new': { title: 'Send later', submitLabel: 'Schedule' },
  'reschedule': { title: 'Change time', submitLabel: 'Save time' },
  'reschedule-failed': { title: 'Reschedule', submitLabel: 'Schedule' },
}

// The Send later panel's title and its custom time's button.
 const sendLaterPanelText = (kind) => SEND_LATER_TEXT[kind]; exports.sendLaterPanelText = sendLaterPanelText

// The bar above the composer while a scheduled message's text is in it, and
// the Send button's label then.
 const scheduledEditBarText = (
  { message, mode },
  now = new Date(),
  timeZone = _timeZones.deviceTimeZone.call(void 0, ),
) => mode === 'reschedule'
  ? {
      title: "Rescheduling a message that wasn't sent",
      detail: exports.failureReasonText.call(void 0, message.FailureReason),
      stopLabel: 'Stop rescheduling',
      saveLabel: 'Reschedule',
    }
  : {
      title: 'Editing scheduled message',
      detail: `Sends ${exports.formatScheduledTime.call(void 0, message.SendAt, now, timeZone)}`,
      stopLabel: 'Stop editing',
      saveLabel: 'Save',
    }; exports.scheduledEditBarText = scheduledEditBarText

// The inbox row's pill for a chat with a failed scheduled message nobody has
// dismissed, and what screen readers hear for it.
 const UNSENT_SCHEDULED_PILL_TEXT = '● Not sent'; exports.UNSENT_SCHEDULED_PILL_TEXT = UNSENT_SCHEDULED_PILL_TEXT
 const UNSENT_SCHEDULED_PILL_LABEL = 'Scheduled message not sent'; exports.UNSENT_SCHEDULED_PILL_LABEL = UNSENT_SCHEDULED_PILL_LABEL

// The toast after Cancel, which offers Undo while it can.
 const SCHEDULED_CANCELLED_TEXT = 'Scheduled message cancelled.'; exports.SCHEDULED_CANCELLED_TEXT = SCHEDULED_CANCELLED_TEXT

// The server's public refusals of a send time (pkg/bloom/scheduled_message.go).
const SERVER_TEXT = {
  'send time must be at least a minute from now': 'Pick a time at least a minute from now.',
  'send time must be within a year from now': 'Pick a time within a year from now.',
  'scheduled message text is empty': "A scheduled message can't be empty.",
  'scheduled message not found': 'This scheduled message is gone.',
  'only the author can change this scheduled message': 'Only the person who scheduled it can change it.',
}

// The server's own words for a refused retry ("can't retry: the patient has
// opted out of texts"), as a sentence.
const retryRefusedText = (message) =>
  message ? `${message.charAt(0).toUpperCase()}${message.slice(1)}.` : "Can't retry this message."

// What to tell staff when a scheduled-message command is refused.
 const scheduledErrorText = (error, fallback) => {
  const { code, current, message } = exports.scheduledMessageErrorFrom.call(void 0, error)
  if (code === 'scheduled_message_changed') return exports.STALE_MESSAGE_TEXT
  if (code === 'scheduled_message_retry_refused') return retryRefusedText(message)
  if (code === 'scheduled_message_not_scheduled') {
    // A teammate on its team may have cancelled it.
    if (_optionalChain([current, 'optionalAccess', _ => _.Status]) === 'cancelled') {
      return current.UpdatedByName ? `${current.UpdatedByName} cancelled this message.` : 'This message was cancelled.'
    }
    return (current && MOVED_ON_TEXT[current.Status]) || fallback
  }
  return (message && SERVER_TEXT[message]) || fallback
}; exports.scheduledErrorText = scheduledErrorText
